var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderMsgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31315 19.706L7.43133 17.4417H10.945C12.1876 17.4417 13.195 16.4344 13.195 15.1917L13.195 9.5C13.195 8.25736 12.1877 7.25 10.945 7.25H2.25C1.00736 7.25 0 8.25736 0 9.5V15.1917C0 16.4344 1.00736 17.4417 2.25 17.4417H2.32869V18.6945C2.32869 19.7157 3.48684 20.306 4.31315 19.706Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49316 3.02734C2.49316 1.50856 3.72438 0.277344 5.24316 0.277344H17.2432C18.7619 0.277344 19.9932 1.50856 19.9932 3.02734V11.0158C19.9932 12.3883 18.9509 13.5173 17.6148 13.6545V16.3982C17.6148 17.448 16.399 18.0302 15.5811 17.372L14.4689 16.477C14.6152 16.076 14.695 15.6431 14.695 15.1915L14.695 9.49981C14.695 7.42874 13.0161 5.74981 10.945 5.74981H2.49316V3.02734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMsgIcon);
export default __webpack_public_path__ + "static/media/header-msg-icon.42fc511333ac80dca44ca30116e36c62.svg";
export { ForwardRef as ReactComponent };